import { render, staticRenderFns } from "./dicItemDrawer.vue?vue&type=template&id=65c4510d&scoped=true&"
import script from "./dicItemDrawer.vue?vue&type=script&lang=js&"
export * from "./dicItemDrawer.vue?vue&type=script&lang=js&"
import style0 from "./dicItemDrawer.vue?vue&type=style&index=0&id=65c4510d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4510d",
  null
  
)

export default component.exports